export const jotformMixins = {
  methods: {
    allJotforms () {
      this.$http.get('/jotforms')
        .then(response => this.showJotforms(response))
        .catch((e) => this.error(e))
    },

    showJotforms (response) {
      this.jotforms = response.data
    },

    selectJotform (id) {
      var j = this.jotforms.find(function (j) {
        return j.id === id
      })
      this.setJotform(j)
    },

    setJotform (j) {
      this.jotform = j
    },

    resetJotform (id) {
      if (typeof id !== 'undefined') {
        this.$http.get('/jotforms/' + id)
          .then(response => this.setJotform(response.data))
          .catch((e) => this.error(e))
      } else {
        this.setBlankJotform()
      }
    },

    setBlankJotform () {
      this.jotform = {
        name: '',
        form_id: '',
        mailbox_id: ''
      }
    },

    error (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jotformMixins.js